import store from '@/store';

export default async (to, from, next) => {
  if (store.getters['user/needChangeTemporaryPassword']) {
    next({ name: 'change-password' });
  } else {
    next();
  }
};
